<template>
  <v-row style="min-width: 980px; max-width: 1200px">
    <v-col
      cols="8"
      offset="2"
      class="step-line">
      <v-chip
        dark
        :color="color"
        x-large
        class="step-mark">
        &nbsp;{{ mark }}&nbsp;
      </v-chip>
      <v-card
        class="menu-box"
        color="white"
        light>
        <div
          class="title-bar"
          :style="{ 'background-color': color }">
          <v-icon
            size="32"
            dark
            v-text="icon" />
          <slot name="title"></slot>
        </div>
        <v-row
          class="pl-3"
          style="height: 110px">
          <v-col
            cols="9">
            <v-card-subtitle>
              <slot name="subtitle"></slot>
            </v-card-subtitle>
          </v-col>
          <v-col
            cols="3"
            align-self="end"
            class="text-right pr-5">
            <slot name="actions"></slot>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TopMenuCard',
  props: {
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    mark: {
      type: String,
      default: null,
    },
  },
  methods: {
  },
}
</script>

<style scoped>

.menu-box {
  margin-left: 50px;
  height: 160px;
}
.step-mark1 {
  margin-left: -30px;
}
.step-mark {
  margin-left: -35px; margin-top: 45px; position: absolute
}
.step-line {
  border-left: 3px solid rgba(0,0,0,.12);
}
.icon-col {
  min-width: 70px;
}
.title-bar {
  height: 44px;
  color: white;
  font-size: 22px;
  font-weight: bold;
  line-height: 44px;
  padding: 0 0 0 12px;
}
</style>
